import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    sessionStorage.removeItem("mpc_msg_banner_hidden");
    setUser(data);
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    sessionStorage.removeItem("mpc_msg_banner_hidden");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}
